export default __webpack_public_path__ + "static/media/acControllerSuccessIcon.92d5539d.svg";